import { render, staticRenderFns } from "./CustomImage.vue?vue&type=template&id=49de3c85&scoped=true"
import script from "./CustomImage.vue?vue&type=script&lang=js"
export * from "./CustomImage.vue?vue&type=script&lang=js"
import style0 from "./CustomImage.vue?vue&type=style&index=0&id=49de3c85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49de3c85",
  null
  
)

export default component.exports